module.exports = __webpack_public_path__ + "static/assets/d760eb306b9e48d2c9791790dec0b5a2.png";